import Splide from '@splidejs/splide';

const slider = () => {
	document.querySelectorAll('[data-js=splide]').forEach((splide) => {
		new Splide(splide, {
			type: 'carousel',
			start: 1,
			focus: 'center',
			perPage: 2.29,
			gap: 32,
			breakpoints: {
				1439: {
					perPage: 1.268,
				},
				767: {
					gap: 16,
					perPage: 1.185,
				},
			},
			pagination: false,
		}).mount();
	});

	document.querySelectorAll('[data-js=splide2]').forEach((splide) => {
		new Splide(splide, {
			type: 'carousel',
			start: 1,
			focus: 'center',
			perPage: 2.29,
			gap: 32,
			breakpoints: {
				1439: {
					start: 0,
					focus: 'left',
					perPage: 1.268,
					gap: 32,
				},
				767: {
					start: 0,
					focus: 'left',
					perPage: 1.185,
					gap: 16,
				},
			},
			pagination: false,
		}).mount();
	});
};

export default slider;
